import axios from 'axios';
import { Base_URL } from "../url";

const apiClient = axios.create({
  baseURL: Base_URL,
  timeout: 300000,
});

// Enhanced getProfileData with all sections
export const getProfileData = async () => {
  try {
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    const mavUserId = userDetails.userId;
    
    const response = await apiClient.get(`/Profile/${mavUserId}`);
    console.log(response.data)
    return response.data;
  } catch (error) {
    console.error('Error fetching profile data:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch profile data');
  }
};

// NEW: Update profile data function
export const updateProfileData = async (updateData) => {
  try {
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    const mavUserId = userDetails.userId;
    
    const response = await apiClient.put(`/Profile?mavUserIdNEW=${mavUserId}`, updateData);
    return response.data;
  } catch (error) {
    console.error('Error updating profile data:', error);
    throw new Error(error.response?.data?.message || 'Failed to update profile data');
  }
};




// Add to your existing API methods
export const experienceService = {
  // Add new experience
  addExperience: async (mavUserId, experienceData) => {
    try {
      const response = await apiClient.post(`/Profile/${mavUserId}/experiences`, experienceData);
      return response.data;
    } catch (error) {
      console.error('Error adding experience:', error);
      throw new Error(error.response?.data?.message || 'Failed to add experience');
    }
  },

  // Delete experience
  deleteExperience: async (mavUserId, expId) => {
    try {
      const response = await apiClient.delete(`/Profile/${mavUserId}/experiences/${expId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting experience:', error);
      throw new Error(error.response?.data?.message || 'Failed to delete experience');
    }
  }
  // GET all leave records


};